export const en = {
    "k_f580681d": "You do not have permission to access this project",
    "k_9bd8dca9": "Failed to obtain project information: {arg_0}",
    "k_4b1cc655": "Initializing the AI project...",
    "k_7f5a357e": "You do not have edit rights for this project",
    "k_b4d112af": "Failed to initialize AI project: {arg_0}",
    "k_21b8a7b6": "AI project was successfully initialized"
};
